import React from "react"
import { HorizontalBar } from "react-chartjs-2"
import UserTimecardStore from "../../../stores/UserTimecardStore"
import { IUserDocument, ITimecardDay, IObjectTimecardDocument } from "../../../models"
import * as api from "../../../api"
import moment from "moment"
interface IProps {
    user: IUserDocument
}
interface IState {
    isLoading: boolean
    data: {
        labels: string[]
        datasets
    }
}

export default class UserDetailChartSummary extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,
            data: {
                labels: [],
                datasets: []
            }
        }
    }

    componentDidMount() {
        const data = []
        const _labels = []
        const dates = []
        dates.push(UserTimecardStore.getReferenceDate())
        dates.push(moment().subtract(1, "w"))
        api.getUserTimecards(this.props.user.Id, moment(dates[0]).utc(true).format()).then(res => {
            const timecard: IObjectTimecardDocument = res.data
            timecard.MasterTimecard.TimecardWeeks[0].Days.forEach((_day: ITimecardDay) => {
                data.push(parseFloat((_day.TotalDurationInMinutes / 60).toFixed(2)))
                _labels.push(moment(timecard.MasterTimecard.TimecardTimeZoneOffset > 0 ? _day.EndDayTime : _day.StartDayTime).format("M/D/YYYY"))
            })
            this.setState({
                data: {
                    labels: _labels,
                    datasets: [{ data }]
                },
                isLoading: false
            })
        })
    }

    render() {
        const graphWidth: HTMLElement = document.getElementsByClassName("WrapperUserDetailChartSummary")[0] as HTMLElement
        return this.state.isLoading ?
            null :
            <div style={{ paddingRight: 35, paddingLeft: 35 }}>
                <HorizontalBar
                    data={this.state.data}
                    options={{
                        title: {
                            display: true,
                            text: "Hours Worked Per Day",
                            fontSize: 18
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        legend: {
                            display: false
                        },
                        scales: {
                            xAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }
                            ]
                        }
                    }}
                    width={graphWidth.offsetWidth - 70}
                    height={350}
                />
            </div>
    }
}
